import clsx from "clsx"
import { FC } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useCanPurchaseSaleChestQuery } from "store/apis/saleChestAPI"
import { hapticFeedback } from "utils/hapticFeedback"
import { SaleChestTimer } from "./ui/sale-chest-timer"
import { preSaleChestIcon } from "assets/icons"
import styles from "./index.module.scss"

export const SideMenuSaleChest: FC = () => {
  const { i18n } = useTranslation()
  const { data: canPurchaseData, refetch } = useCanPurchaseSaleChestQuery()

  const canPurchase = canPurchaseData?.canPurchase ?? true
  const availableAt = canPurchaseData?.availableAt

  return (
    <Link
      id="btn-sale-chest"
      to="/sale-chest"
      className={clsx(styles.SideMenuSaleChest, styles[i18n.language])}
      onClick={() => {
        hapticFeedback()
      }}
    >
      <img src={preSaleChestIcon} alt="sale-chest" />
      {canPurchase ? (
        <div className={clsx(styles.SideMenuSaleChest_label)}>presale</div>
      ) : (
        availableAt && (
          <div className={clsx(styles.SideMenuSaleChest_timer)}>
            <SaleChestTimer date={availableAt} onExpire={refetch} />
          </div>
        )
      )}
    </Link>
  )
}
